import { render } from "./MaterialAdmin.vue?vue&type=template&id=2eb7697f&scoped=true"
import script from "./MaterialAdmin.vue?vue&type=script&lang=js"
export * from "./MaterialAdmin.vue?vue&type=script&lang=js"

import "./MaterialAdmin.vue?vue&type=style&index=0&id=2eb7697f&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eb7697f"]])

export default __exports__